export function descriptionVersions(profile) {
  const versions = { ...(profile.description || {}) };
  // Older registration copied one text to both languages: keep it as an original.
  if (!profile.original_language && versions.it && versions.it === versions.en) return { [profile.original_language || 'it']: versions.it };
  return versions;
}
export function localizedProfileText(versions, language, original = 'it') {
  const source = versions?.[language]?.trim() ? language : versions?.[original]?.trim() ? original : ['it', 'en'].find(key => versions?.[key]?.trim());
  return { text: versions?.[source] || '', source, fallback: !!source && source !== language };
}
